import React from "react";
import "./App.css";

import Header from "./components/Header";
import Main from "./components/Main";
function App() {
  return (
    <div>
      {/* <Particles className="particles" params={config} /> */}
      <Header />
      <Main />
    </div>
  );
}

export default App;
